/**
 * Clean URL parameters safely
 * Removes stkn immediately
 * Removes marketing params after load so pixels can capture them first
 */
(function () {
  try {
    var safeToRemove = ["stkn"];

    var marketingParams = [
      "gclid",
      "fbclid",
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_term",
      "utm_content"
    ];

    function cleanUrl(paramsList) {
      try {
        var url = new URL(window.location.href);
        var updated = false;

        paramsList.forEach(function (param) {
          if (url.searchParams.has(param)) {
            url.searchParams.delete(param);
            updated = true;
          }
        });

        if (updated) {
          var newUrl =
            url.pathname +
            (url.search ? url.search : "") +
            (url.hash ? url.hash : "");

          window.history.replaceState({}, "", newUrl);
        }
      } catch (e) {}
    }

    cleanUrl(safeToRemove);

    window.addEventListener("load", function () {
      setTimeout(function () {
        cleanUrl(marketingParams);
      }, 1000);
    });
  } catch (e) {}
})();
